import type { IModuleDefinition, IModuleStrings } from '@platform/core/types';

/**
 * Текст значення варіанта, якого власне поле простору (ADR-023 customFields — варіанти зазвичай без підпису) само не перекладає: прототип
 * v4 пропускає кожне значення через свій словник, тож «Email» показується як «Ел. пошта». Беремо переклад того самого значення з
 * опублікованих полів типу запису, далі — зі статусів, далі — з інших типів записів модуля; без перекладу — undefined. Чиста функція.
 */
export function sameValueText(base: IModuleStrings, published: IModuleDefinition, rtKey: string, value: string): string | undefined {
  const own = published.recordTypes.find((r) => r.key === rtKey);
  const others = published.recordTypes.filter((r) => r.key !== rtKey);
  for (const rt of own ? [own, ...others] : others) {
    for (const field of rt.fields) {
      const option = field.options?.find((o) => o.value === value);
      if (!option) continue;
      const text = base.option(rt.key, field.key, value, option.label ?? null);
      if (text && text !== value) return text;
    }
    const status = base.status(rt.key, value, null);
    if (status && status !== value) return status;
  }
  return undefined;
}
